// "use strict";

angular.module('app.factories.enum', []).// app.factories.enum-module

// -------------------------------------------//
//               f_Info is for Popups
// -------------------------------------------//

factory('ENUM', ['$rootScope', '__Enum',
    function ($rootScope, __Enum) {

        var enums = {}; // = new Array();


        return {
            resolveMostUsed: function () {
                return __Enum.$build({
                    FilterConfigurations: [
                        {
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": 1
                        },
                        {
                            // with SceneConditions
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": 4

                        },
                        {
                            // with SceneActions
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": 3

                        },
                        {
                            // with adress
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": 6

                        },
                        {
                            // passive devices
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": 7
                        },

                        {
                            "EnumName": "BMSProtocol",
                            "FilterProfile": 1
                        },
                        {
                            "EnumName": "BMSUserLevel",
                            "FilterProfile": 1
                        },
                        {
                            // passive devices
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": 9
                        }

                      /*  {
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": 8
                        }*/
                    ]
                }).$save().$then(function (data) {
                    enums = data;
                });
            },
            getEnum: function (e, filter) {
                if (enums && enums[e]) {
                    return enums[e];
                } else {
                    return __Enum.$collection().$fetch({
                        FilterConfigurations: [{
                            "EnumName":e,
                            "FilterProfile": (filter ? filter : -1)
                        }]
                    }).$then(function (data) {
                        enums[e] = data;
                    });
                }
            },
            getDeviceTypesByFilter: function (filterProfile) {
                if (enums && enums['BMSDeviceType'] && enums['BMSDeviceType'][filterProfile]) {
                    return enums['BMSDeviceType'][filterProfile];
                } else {
                    return __Enum.$collection().$fetch({
                        FilterConfigurations: [{
                            "EnumName": "BMSDeviceType",
                            "FilterProfile": filterProfile
                        }]
                    }).$then(function (data) {
                        if(enums['BMSDeviceType'] == undefined){ enums['BMSDeviceType'] = {} }
                        enums['BMSDeviceType'][filterProfile] = data;
                    });
                }
            },
            getProtocols: function () {
                if (enums && enums['BMSProtocol'] && enums['BMSProtocol'][1]) {
                    return enums['BMSProtocol'][1];
                }
            },
            updateAll: function () {
                // build all enums array
                var allEnums = [];
                for (var enumName in enums) {
                    if (!(!isNaN(parseFloat(enumName)) && isFinite(enumName)) && enumName.charAt(0) !== '$' && enumName.localeCompare('FilterConfigurations') !== 0) {
                        for (var filterProfile in enums[enumName]) {
                            if (!isNaN(parseFloat(filterProfile)) && isFinite(filterProfile)) {
                                allEnums.push({
                                    "EnumName": enumName,
                                    "FilterProfile": parseInt(filterProfile)
                                });
                            }
                        }
                    }
                }
                // update enums
                if(allEnums.length > 0) {
                    return __Enum.$build({ FilterConfigurations: allEnums }).$save().$then(function (data) {
                        enums = data;
                        $rootScope.$broadcast('$enumsUpdated');
                    });
                } else {
                    return undefined;
                }
            }
        };
    }]);
